import { Body1, ButtonText, Headline2, Headline5 } from 'stories/elements/Typography/Text'
import { deviceSize } from 'lib/constants/GridBreakpoints'
import theme from 'stories/utils/theme'
import useMedia from 'lib/hooks/useMedia'
import React from 'react'
import styled from 'styled-components'
import DynamicButton from './DynamicButton'

const Container = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 50px;
    padding-bottom: 100px;
    @media (max-width: 1050px) {
        height: auto;
    }
`

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 20px;
    row-gap: 30px;
    @media (max-width: 1250px) {
        grid-template-columns: 1fr;
    }
`

const InformationCard = styled.div`
    height: 380px;
    width: 380px;
    position: relative;
    padding: 25px;
    background-color: ${theme.colors.white};
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    border-radius: ${theme.borderRadius.huge};
    border: 3px solid ${theme.colors.accentBlue};
    box-shadow: 4px 4px 0px ${theme.colors.accentBlue}, 38px 43px 45px rgba(0, 0, 0, 0.04);
    h5 {
        min-height: 90px;
    }
    @media (max-width: 750px) {
        height: auto;
        width: 100%;
        h5 {
            min-height: 50px;
        }
    }
`

interface Props {
    items: {
        title: string
        subtitle: string
    }[]
    buttonText: string
    buttonLink: string
    buttonColor: string
}

const AdvantageGrid = ({ items, buttonText, buttonLink, buttonColor }: Props) => {
    const md = useMedia(deviceSize.md)

    return (
        <Container>
            <Grid>
                {md ? (
                    <InformationCard>
                        {items.map((item, i) => (
                            <>
                                <Headline2 color={theme.colors.accentBlue}>{i + 1}</Headline2>
                                <Headline5 color={theme.colors.accentBlue} marginBottom={30} textAlign="center">
                                    {item.title}
                                </Headline5>
                            </>
                        ))}
                    </InformationCard>
                ) : (
                    <>
                        {items.map((item, i) => (
                            <InformationCard key={`information-card-${i}`}>
                                <Headline2 color={theme.colors.accentBlue}>{i + 1}</Headline2>
                                <Headline5 color={theme.colors.accentBlue} textAlign="center">
                                    {item.title}
                                </Headline5>
                                <Body1 color={theme.colors.body2Black} textAlign="center" fontWeight={600}>
                                    {item.subtitle}
                                </Body1>
                            </InformationCard>
                        ))}
                    </>
                )}
            </Grid>
            {buttonText && buttonLink ? (
                <DynamicButton
                    href={buttonLink}
                    width={280}
                    height={60}
                    borderRadius={theme.borderRadius.normal}
                    color={buttonColor ?? theme.colors.accentBlue}
                >
                    <ButtonText color={theme.colors.white}>{buttonText}</ButtonText>
                </DynamicButton>
            ) : null}
        </Container>
    )
}

export default AdvantageGrid
